import type {DataRouterApplicationBuilder} from '@github-ui/react-core/future/data-router-application'
import {repoAppBuilder} from '@github-ui/repo-app-builder'

export function buildRepositoryProjectsRoute(appBuilder: DataRouterApplicationBuilder<string>) {
  return appBuilder.createQueryRouteConfig('repositoryProjectsRoute', {
    path: '/:owner/:repo/projects',
    queries: [],
  })
}

export const repositoryProjectsRoute = buildRepositoryProjectsRoute(repoAppBuilder)
